import { useLocation } from 'react-router-dom';

export const useCompetencyQueryParams = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const employeeId = queryParams.get('empId');
  const competencyId = queryParams.get('competencyId');
  const scrollToId = queryParams.get('scrollToId');
  const isCompetencyPanelOpen = queryParams.get('isCompetencyPanelOpen');
  const isSharePublicPraise = queryParams.get('isSharePublicPraise');

  return { employeeId, competencyId, scrollToId, isCompetencyPanelOpen, isSharePublicPraise };
};
